import React, { useEffect, useState } from "react";
import AdjustTons from "../AdjustTons/AdjustTons";
import TruckDetails from "../TruckDetails/TruckDetails";
import calculatorIcon from "../../../../../../../../Assets/images/calculator-icon.svg";
import trackIcon from "../../../../../../../../Assets/images/track-icon.png";
import trackIconOff from "../../../../../../../../Assets/images/track-black-icon.png";

import apiClient from "../../../../../../../../Config/apiClient";
import { ClipLoader } from "react-spinners";
import { showErrorToast } from "../../../../../../../../Context/Toaster/Toaster";
import moment from "moment";
import "./TruckLists.scss";
import { DATE_FORMAT } from "../../../../../Utils/Constants";
import { jwtDecode } from "jwt-decode";

const TruckUrl = process.env.REACT_APP_TC_TRUCK_BASE_PATH;

const TrucksTab = ({ jobId, refresh, jobData }) => {
  const [trucks, setTrucks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTruckDetails, setShowTruckDetails] = useState(false);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [showAdjustTons, setShowAdjustTons] = useState(false);
  const [selectedTruckJob, setSelectedTruckJob] = useState(null);

  useEffect(() => {
    if (jobId) fetchTrucks();
  }, [jobId, refresh]);

  const getCompanyId = () => {
      const token = localStorage.getItem("accessToken");
      if (!token) return null;
      try {
        const decoded = jwtDecode(token);
        return decoded.company_id;
      } catch {
        return null;
      }
    };

  const fetchTrucks = async () => {
    try {
      setLoading(true);
      if (!TruckUrl) throw new Error("TruckUrl is undefined");
      const companyId = getCompanyId();
      if (!companyId) throw new Error("Company ID not found in token");

      const response = await apiClient.get(
        `${TruckUrl}/trucks/${jobId}`,
        { params: { tc_company_id: companyId } }
      );
      const data = response.data?.data || [];
      setTrucks(data);
    } catch (error) {
      console.error("Error fetching trucks:", error);
      showErrorToast("Failed to load trucks");
    } finally {
      setLoading(false);
    }
  };

  const openTruckDetails = async (e, truck) => {
    e.preventDefault();
    const truckId = truck?.truckDetails?.truck_id;
    if (!truckId) return showErrorToast("Truck ID not found");

    try {
      setLoading(true);
      const response = await apiClient.get(`${TruckUrl}/details/${truckId}`);
      const detailedTruck = response.data?.data;

      if (!detailedTruck) return showErrorToast("Truck details not found");

      setSelectedTruck({
        ...detailedTruck,
        driverDetails: truck.driverDetails,
        driver: `${truck.driverDetails?.first_name || ""} ${truck.driverDetails?.last_name || ""}`.trim()
      });

      setShowTruckDetails(true);
    } catch (error) {
      console.error("Error fetching truck details:", error);
      showErrorToast("Failed to fetch truck details.");
    } finally {
      setLoading(false);
    }
  };

  const closeTruckDetails = () => {
    setShowTruckDetails(false);
    setSelectedTruck(null);
  };

  const getUnitLabel = (paymentType) => {
    if (paymentType === 2 || paymentType === "Hours" || paymentType === "Hour") return "Hours";
    if (paymentType === 3 || paymentType === "Loads" || paymentType === "Load") return "Loads";
    return "Tons";
  };

  return (
    <>
      <div className="tr-inner">
        <div className="trt-wraper">
          {loading ? (
            <div className="text-center py-4">
              <ClipLoader size={35} />
            </div>
          ) : (
            <table className="table trucks-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Truck ID</th>
                  <th>Driver</th>
                  <th>Job Accepted</th>
                  <th className="align-text">Work Done</th>
                </tr>
              </thead>
              <tbody>
                {trucks.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      No trucks found for this job.
                    </td>
                  </tr>
                ) : (
                  trucks.map((truck, index) => {
                    const truckId = truck.truckDetails?.truck_id;
                    const driverName = `${truck.driverDetails?.first_name || ""} ${truck.driverDetails?.last_name || ""}`.trim();
                    const jobAccepted = moment(truck.applied_datetime).local().format(DATE_FORMAT);
                    const tonsDumped = truck.work_done;

                    const tracked = false;

                    return (
                      <tr key={truck.id}>
                        <td>{index + 1}</td>
                        <td>
                          <a href="#" onClick={(e) => openTruckDetails(e, truck)}>
                           T-{truckId || "--"}
                          </a>
                        </td>
                        <td>
                          <a href="#" onClick={(e) => openTruckDetails(e, truck)}>
                            {driverName || "--"}
                          </a>
                        </td>
                        <td>{jobAccepted}</td>
                        <td className="align-text">
                          {tonsDumped != null && !isNaN(tonsDumped)
                            ? `${Number(tonsDumped).toFixed(2)} ${getUnitLabel(jobData?.payment_type)}`
                            : "--"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <AdjustTons
        show={showAdjustTons}
        onClose={() => {
          setShowAdjustTons(false);
          setSelectedTruckJob(null);
          refresh();
        }}
        truckJobId={selectedTruckJob?.id}
        jobData={jobData}
        truckDetails={{
          truckId: selectedTruckJob?.truckDetails?.truck_id,
          licensePlate: selectedTruckJob?.truckDetails?.license_plate_no,
          vehicleNumber: selectedTruckJob?.truckDetails?.vehicle_no,
          truckType: selectedTruckJob?.truckDetails?.truck_type,
        }}
        initialWorkDone={selectedTruckJob?.work_done}
      />

      <TruckDetails truck={selectedTruck} show={showTruckDetails} onClose={closeTruckDetails} />
      </>
  );
};

export default TrucksTab;
